import axiosInstance from './AxiosInstance';

class DelimitationService {

  constructor() {
    this.endpoint = "/api/delimitation"
  }

  async getDistricts() {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/national/districts`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
  async getLocalDistricts() {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/local/districts`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }


  async getConstituenciesByDistrict(districtID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/national/constituencies/district/${districtID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
  async getCouncilsByDistrict(districtID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/local/Council/${districtID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getPollingDivisionsByConstituency(constituencyID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/national/pollingdivisions/constituency/${constituencyID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getRegistrationCentresByPollingDivision(pollingDivisionID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/national/registrationcentres/pollingdivision/${pollingDivisionID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getRegistrationCentresByConstituency(constituencyID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/local/registrationcentres/constituency/${constituencyID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getVillagesByRegistrationCentre(registrationCentreID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/national/villages/registrationcentre/${registrationCentreID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
  async getLocalVillagesByRegistrationCentre(registrationCentreID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/local/villages/registrationcentre/${registrationCentreID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async GetLocalVotingDistrictsByCouncilIdAsync(councilID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/local/votingdistrict/constituency/${councilID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetkching data:', error);
      throw error;
    }
  }
  async GetLocalVotingStationByElectorDivisionIDAsync(electorDivisionId) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/local/votingstation/${electorDivisionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetkching data:', error);
      throw error;
    }
  }

  async getPollingStaionByNationalVotingStation(centreID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/nation/PollingStations/${centreID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
  async getPollingStaionByLocalVotingStation(centreID) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/local/PollingStations/${centreID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
  async createPollingStations(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}/create/polling/stations`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }
  
  async getNationalLocalDistrict(isNational = true) {
    return isNational ? this.getDistricts() : this.getLocalDistricts()
  }
  async getNationalLocalConstituency(isNational = true, districtID) {
    return isNational ? this.getConstituenciesByDistrict(districtID) : this.getCouncilsByDistrict(districtID)
  }

  async getNationalLocalVotingDistrict(isNational = true, id) {
    return isNational ? this.getPollingDivisionsByConstituency(id) : this.GetLocalVotingDistrictsByCouncilIdAsync(id)
  }
  async getNationalLocalgetRegistrationCentres(isNational = true, id) {
    return isNational ? this.getRegistrationCentresByPollingDivision(id) : this.GetLocalVotingStationByElectorDivisionIDAsync(id)
  }

  async createDermacation(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  async updateDermacation(data) {
    try {
      const response = await axiosInstance.put(`${this.endpoint}`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  async move(data) {
    try {
      const response = await axiosInstance.put(`${this.endpoint}/move`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }
  async deactive(data) {
    try {
      const response = await axiosInstance.put(`${this.endpoint}/activate`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }
}

const delimitationService = new DelimitationService();

export { delimitationService };